export const header = {
    ignoreBackButtonCliquedOnHome: true, // Android: quand on clique sur le bouton retour et qu'on et à la racine, quitte l'application
    backRoutes: [] //liste des routes qui ont accès a la fonctionnalité retour sous la forme {origin: "route_depart", destination: "route d'arrivée"}
};
